import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../../utils/helpers/model.helper';

export const RENEWAL_SUBSCRIPTION_SCHEMA = Object.freeze({
  COMPANY_NAME: '',
  COMPANY_EMAIL: '',
  PLAN_UUID: '',
  PLAN_TYPE: '',
  PLAN_NAME: '',
  PURCHASE_WINDOW: '',
});
const RECORD = generateSchema(RENEWAL_SUBSCRIPTION_SCHEMA);
const KEYS: any = generateKeys(RENEWAL_SUBSCRIPTION_SCHEMA);

export class RenewalSubscription extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get companyName(): string {
    return this.get(KEYS.COMPANY_NAME);
  }

  get companyEmail(): string {
    return this.get(KEYS.COMPANY_EMAIL);
  }

  get planUuid(): string {
    return this.get(KEYS.PLAN_UUID);
  }

  get planType(): string {
    return this.get(KEYS.PLAN_TYPE);
  }

  get planName(): string {
    return this.get(KEYS.PLAN_NAME);
  }

  get purchaseWindow(): string {
    return this.get(KEYS.PURCHASE_WINDOW);
  }
}
